export const placeholderImg = '/images/transparent-placeholder.png'